import React from 'react'
import Header from '../components/Header'
import HeaderUS from '../components/HeaderUS'
import DiscontinuationBanner, { useShowDiscontinuationBanner } from '../components/DiscontinuationBanner';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomePageLayout() {
    const { i18n } = useTranslation()
    const showBanner = useShowDiscontinuationBanner();
    const header = i18n.language === 'en' ? <HeaderUS /> : <Header />

    if (!showBanner) {
        return (
            <div style={{ paddingTop: 140 }}>
                {header}
                <Outlet />
            </div>
        )
    }

    return (
        <div>
            <div style={{ position: 'sticky', top: 0, zIndex: 11 }}>
                <DiscontinuationBanner />
                {/* transform makes the fixed header sit right below the banner */}
                <div style={{ transform: 'translateZ(0)' }}>{header}</div>
            </div>
            <div style={{ paddingTop: 140 }}>
                <Outlet />
            </div>
        </div>
    )
}

export default HomePageLayout
